export const hexToRgba = (hex: string, opacity: number) => {
	hex = hex.replace('#', '');

	if (hex.length === 3) {
		hex = hex
			.split('')
			.map((c) => c + c)
			.join('');
	}

	const r = parseInt(hex.slice(0, 2), 16);
	const g = parseInt(hex.slice(2, 4), 16);
	const b = parseInt(hex.slice(4, 6), 16);

	opacity = Math.max(0, Math.min(1, opacity));

	return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
